export default "__VITE_ASSET__Dm$8o7n0__"